import { useMemo } from 'react';

export type SectionState = { readonly name: string; readonly ready: boolean; readonly error?: unknown };

export type SectionGate = { readonly ready: boolean; readonly reason?: string };

export function sectionStateOf(name: string, query: { ready: boolean; error?: unknown }): SectionState {
  return { name, ready: query.ready, error: query.error };
}

export function sectionGate(required: readonly SectionState[]): SectionGate {
  const failed = required.find((section) => !section.ready && section.error != null);
  if (failed) return { ready: false, reason: `${failed.name} could not load. Retry ${failed.name} to continue.` };

  const pendingNames = required.filter((section) => !section.ready).map((section) => section.name);
  if (pendingNames.length > 0) return { ready: false, reason: `Waiting for ${pendingNames.join(', ')} to load.` };

  return { ready: true };
}

export function useSectionGate(required: readonly SectionState[]): SectionGate {
  const { ready, reason } = sectionGate(required);
  return useMemo(() => (reason === undefined ? { ready } : { ready, reason }), [ready, reason]);
}
